export const DEFAULT_COUNTRY_CODE = '+49'

export const checkIfPhoneIsValid = (phone: string) => {
  if (phone === DEFAULT_COUNTRY_CODE || phone === '') {
    return true
  }

  const phoneRegex = /^(\+)\d{11,15}$/
  return phoneRegex.test(phone)
}
